import { union } from "ts-action";
import { Middleware } from "redux";
import { notificationsConnection } from "../../requests/signalRConnections";
import * as AC from "../notifications/actionCreators";
import {
  getMappingNotifications,
  getTemplateNotificationMessages,
} from "../notifications/selectors";
import { SignalRNotification } from "../../globalTypes";

const allNotificationActions = union(...Object.values(AC));

export const signalRMiddleware: Middleware =
  ({ dispatch, getState }) =>
  // ten typeof allNotificationActions.actions trochu ojeb, realne sem muze prijit jakakoliv
  // akce, ale funguje to takhle dobre s tim guardingem :))
  (next) =>
  async (action: typeof allNotificationActions.actions) => {
    switch (action.type) {
      // "SMART" ACTIONS
      case AC.handleNotificationDismiss.type: {
        const { id } = action.payload;
        const findMsg = (m: SignalRNotification) => m.notificationId === id;

        const mappingMsgs = getMappingNotifications(getState());
        const mappingAttempt = mappingMsgs.find(findMsg);
        if (mappingAttempt !== undefined) {
          const { datasourceId } = mappingAttempt;
          dispatch(
            AC.dismissMappingNotificationForDatasource({ datasourceId })
          );
          return undefined;
        }

        const templateMsgs = getTemplateNotificationMessages(getState());
        const templateAttempt = templateMsgs.find(findMsg);
        if (templateAttempt !== undefined) {
          const { notificationId } = templateAttempt;
          dispatch(AC.requestResolveNotification({ notificationId }));
          return undefined;
        }

        return undefined;
      }

      // // BASIC ACTIONS
      // case AC.requestTemplateNotifications.type: {
      //   notificationsConnection
      //     .invoke("requestSendTemplateNotificationsToUser")
      //     .catch(() => dispatch(AC.errorRequestTemplateNotifications()));
      //   return next(action);
      // }

      // case AC.requestSystemNotifications.type: {
      //   notificationsConnection
      //     .invoke("requestSendSystemNotificationsToUser")
      //     .catch(() => dispatch(AC.errorRequestSystemNotifications()));
      //   return next(action);
      // }

      case AC.requestResolveNotification.type: {
        const { notificationId } = action.payload;

        notificationsConnection
          .invoke("requestResolveNotification", notificationId)
          .then(() =>
            dispatch(AC.receiveResolveNotification({ notificationId }))
          )
          .catch(() =>
            dispatch(
              AC.receiveResolveNotification(
                new Error(`Failed to resolve notification #${notificationId}`)
              )
            )
          );
        return undefined;
      }

      case AC.requestResolveNotifications.type: {
        const { notificationIds } = action.payload;

        notificationsConnection
          .invoke("requestResolveNotifications", notificationIds)
          .then(() =>
            dispatch(AC.receiveResolveNotifications({ notificationIds }))
          )
          .catch(() =>
            dispatch(
              AC.receiveResolveNotifications(
                new Error(`Failed to resolve notifications: ${notificationIds}`)
              )
            )
          );
        return undefined;
      }

      case AC.terminateNotificationsConnection.type: {
        notificationsConnection
          .stop()
          .then(() => dispatch(AC.resetNotificationsSlice()))
          .catch(); // Tady by to možná chtělo nějakou retry strategii, nevim, pro teď bych neřešil

        return undefined;
      }

      case AC.dismissMappingNotificationForDatasource.type: {
        const { datasourceId } = action.payload;

        const mappingNotifications = getMappingNotifications(getState());

        const idsToResolve = mappingNotifications
          .filter((n) => n.type === "mapping")
          .filter((n) => n.datasourceId === datasourceId)
          .map((n) => n.notificationId);

        const payload = { notificationIds: idsToResolve };
        dispatch(AC.requestResolveNotifications(payload));
        return next(action);
      }

      default:
        return next(action);
    }
  };
